module.exports = __webpack_public_path__ + "ebeb69c2441c2cba749a3abbe0919d18.png";